import { render } from "./BigBoss.vue?vue&type=template&id=a18bc58c"
import script from "./BigBoss.vue?vue&type=script&lang=js"
export * from "./BigBoss.vue?vue&type=script&lang=js"

import "./BigBoss.vue?vue&type=style&index=0&id=a18bc58c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__